export enum ScoreLabel {
  NeedsAttention = 'Needs Attention',
  Developing = 'Developing',
  Moderate = 'Moderate',
  Strong = 'Strong',
  Excellent = 'Excellent',
}

export const SCORE_LABEL_RANGES: { min: number; max: number; label: ScoreLabel }[] = [
  { min: 85, max: 100, label: ScoreLabel.Excellent },
  { min: 70, max: 84, label: ScoreLabel.Strong },
  { min: 50, max: 69, label: ScoreLabel.Moderate },
  { min: 30, max: 49, label: ScoreLabel.Developing },
  { min: 0, max: 29, label: ScoreLabel.NeedsAttention },
];

export enum ScoreColor {
  Excellent = '#04bc00',
  Moderate = '#ff8a4a',
  NeedsAttention = '#dc0808',
  Neutral = '#828282',
}
